var map = {
	"./Alert.svg": 1078,
	"./access.svg": 300,
	"./add_guest.svg": 1079,
	"./arrow_disabled_left.svg": 376,
	"./arrow_disabled_right.svg": 377,
	"./arrow_down.svg": 725,
	"./arrow_down_gray.svg": 449,
	"./arrow_down_nospace.svg": 726,
	"./arrow_down_white.svg": 727,
	"./arrow_down_yellow.svg": 48,
	"./arrow_gray.svg": 333,
	"./arrow_left.svg": 299,
	"./arrow_left_gray.svg": 258,
	"./arrow_left_yellow.svg": 728,
	"./arrow_right.svg": 214,
	"./arrow_right_gray.svg": 257,
	"./arrow_right_gray_nospace.svg": 215,
	"./arrow_right_nospace.svg": 1080,
	"./arrow_up_gray.svg": 729,
	"./arrow_yellow.svg": 259,
	"./arrowleft.svg": 1081,
	"./arrowright.svg": 1082,
	"./asset-format/icon_button1_a.svg": 730,
	"./asset-format/icon_button1_b.svg": 731,
	"./asset-format/icon_button2_a.svg": 732,
	"./asset-format/icon_button2_b.svg": 733,
	"./asset-format/icon_coupon_a.svg": 734,
	"./asset-format/icon_coupon_b.svg": 735,
	"./asset-format/icon_free_a.svg": 736,
	"./asset-format/icon_free_b.svg": 737,
	"./asset-format/icon_image_a.svg": 738,
	"./asset-format/icon_image_b.svg": 739,
	"./asset-format/icon_map_a.svg": 740,
	"./asset-format/icon_map_b.svg": 741,
	"./asset-format/icon_news_a.svg": 742,
	"./asset-format/icon_news_b.svg": 743,
	"./asset-format/icon_pulldown_a.svg": 744,
	"./asset-format/icon_pulldown_b.svg": 745,
	"./asset-format/icon_request_a.svg": 746,
	"./asset-format/icon_request_b.svg": 747,
	"./asset-format/icon_space_a.svg": 748,
	"./asset-format/icon_space_b.svg": 749,
	"./back.svg": 1093,
	"./birthday.svg": 538,
	"./business.svg": 539,
	"./button_arrow_left.svg": 450,
	"./button_arrow_right.svg": 451,
	"./button_trash.svg": 1094,
	"./calendar.svg": 1095,
	"./calendar_icon.svg": 216,
	"./camera.svg": 1096,
	"./camera_icon_gray.svg": 540,
	"./camera_icon_orange.svg": 378,
	"./camera_icon_white.svg": 137,
	"./cancel.svg": 452,
	"./chanel.svg": 750,
	"./check-box.svg": 751,
	"./check-box_off.svg": 752,
	"./check-box_on.svg": 753,
	"./checkin.svg": 1097,
	"./cleaning_manager/icon_arrow_down_yellow.svg": 1098,
	"./cleaning_manager/icon_calender_arrow_left.svg": 754,
	"./cleaning_manager/icon_calender_arrow_right.svg": 755,
	"./cleaning_manager/icon_comment.svg": 379,
	"./cleaning_manager/icon_date.svg": 453,
	"./cleaning_manager/icon_instruction.svg": 234,
	"./cleaning_manager/icon_menu.svg": 1099,
	"./cleaning_manager/icon_menu_active.svg": 1100,
	"./cleaning_manager/icon_menu_black.svg": 756,
	"./cleaning_manager/icon_openall_arrow_down.svg": 757,
	"./cleaning_manager/icon_openall_arrow_up.svg": 758,
	"./cleaning_manager/icon_people.svg": 454,
	"./cleaning_manager/icon_reload.svg": 759,
	"./cleaning_manager/icon_report.svg": 1101,
	"./cleaning_manager/icon_request.svg": 1102,
	"./cleaning_manager/icon_sort.svg": 760,
	"./cleaning_manager/mobile/icon_back.svg": 761,
	"./cleaning_manager/mobile/icon_calender_arrow_left.svg": 1103,
	"./cleaning_manager/mobile/icon_calender_arrow_right.svg": 1104,
	"./cleaning_manager/mobile/icon_checkin.svg": 762,
	"./cleaning_manager/mobile/icon_date.svg": 1105,
	"./cleaning_manager/mobile/icon_people.svg": 1106,
	"./cleaning_manager/mobile/logo.svg": 763,
	"./close-camera.svg": 764,
	"./close.svg": 765,
	"./coupons_manager/icon_menu.svg": 1107,
	"./coupons_manager/icon_menu_active.svg": 1108,
	"./create.svg": 1109,
	"./csv.svg": 138,
	"./custom-design/icon_menu_hamburger.svg": 1111,
	"./custom-design/icon_pallet.svg": 766,
	"./custom-design/icon_pulldown.svg": 1112,
	"./customer-manager/icon_check.svg": 455,
	"./customer-manager/icon_check_tag.svg": 1117,
	"./customer-manager/icon_remove.svg": 1118,
	"./customer-manager/icon_tag.svg": 1119,
	"./customer-search.svg": 767,
	"./dashboard/check-out_image.svg": 1120,
	"./dashboard/checkin.svg": 768,
	"./dashboard/checkout.svg": 769,
	"./dashboard/nps_arrow.svg": 1121,
	"./dashboard/nps_image_base.svg": 1122,
	"./dashboard/nps_image_none.svg": 1123,
	"./dashboard/reservation.svg": 770,
	"./dashboard/stay.svg": 771,
	"./date.svg": 541,
	"./deleat.svg": 772,
	"./deleat_icon.svg": 301,
	"./delete.svg": 1124,
	"./delete_black.svg": 773,
	"./delete_gray.svg": 1125,
	"./delete_orange.svg": 162,
	"./delete_white.svg": 774,
	"./delete_yellow.svg": 179,
	"./delivery.svg": 542,
	"./download.svg": 543,
	"./download_white.svg": 775,
	"./eat.svg": 777,
	"./edit.svg": 235,
	"./edit_icon.svg": 1126,
	"./edit_no_margin.svg": 456,
	"./edit_window.svg": 544,
	"./evaluation.svg": 1127,
	"./file_download.svg": 778,
	"./guest.svg": 1130,
	"./header/aipass.svg": 1131,
	"./header/aipassLogo.svg": 536,
	"./header/another_tab.svg": 1132,
	"./header/attention.svg": 1133,
	"./header/button_arrow_down.svg": 535,
	"./header/data-correction-icon-final.svg": 724,
	"./header/help.svg": 723,
	"./header/hotel.svg": 534,
	"./header/ic_play_arrow_24px.svg": 1134,
	"./header/icon_form_edit.svg": 1135,
	"./header/icon_logout.svg": 537,
	"./header/language.svg": 779,
	"./header/news.svg": 717,
	"./header/news_attention.svg": 718,
	"./header/search.svg": 1136,
	"./header/setting.svg": 722,
	"./header/tab_open_hover.svg": 1137,
	"./health-check.svg": 1138,
	"./help.svg": 380,
	"./hotel.svg": 780,
	"./icon-hover.svg": 1140,
	"./icon/logo.svg": 245,
	"./icon_arrow_down.svg": 1141,
	"./icon_arrow_down_2.svg": 302,
	"./icon_arrow_left.svg": 781,
	"./icon_arrow_right.svg": 782,
	"./icon_arrow_up.svg": 1142,
	"./icon_arrow_up_2.svg": 180,
	"./icon_button1.svg": 783,
	"./icon_caalender_left.svg": 100,
	"./icon_caalender_right.svg": 95,
	"./icon_calculator.svg": 1143,
	"./icon_calculator_active.svg": 1144,
	"./icon_calender.svg": 1145,
	"./icon_checkin.svg": 784,
	"./icon_checkin2.svg": 1146,
	"./icon_checkin_active.svg": 1147,
	"./icon_checkin_orange.svg": 457,
	"./icon_checkout.svg": 1148,
	"./icon_checkout_active.svg": 1149,
	"./icon_checkout_black.svg": 785,
	"./icon_clip.svg": 1150,
	"./icon_customer.svg": 1151,
	"./icon_customer_active.svg": 1152,
	"./icon_dashboard.svg": 1153,
	"./icon_dashboard_active.svg": 1154,
	"./icon_delete.svg": 545,
	"./icon_delete2.svg": 546,
	"./icon_delete2_warning.svg": 786,
	"./icon_delete_warning.svg": 547,
	"./icon_down.svg": 548,
	"./icon_down_gray.svg": 1155,
	"./icon_eye_off.svg": 381,
	"./icon_eye_on.svg": 382,
	"./icon_file.svg": 787,
	"./icon_filter_active.svg": 334,
	"./icon_filter_disable.svg": 335,
	"./icon_h1.svg": 788,
	"./icon_h2.svg": 789,
	"./icon_help.svg": 549,
	"./icon_hotel_notice.svg": 790,
	"./icon_keep.svg": 550,
	"./icon_list.svg": 551,
	"./icon_logo.svg": 791,
	"./icon_map_black.svg": 792,
	"./icon_menu_invoice.svg": 1156,
	"./icon_menu_invoice_active.svg": 1157,
	"./icon_more_view_arrow.svg": 552,
	"./icon_other.svg": 303,
	"./icon_plan_name.svg": 1158,
	"./icon_reservation.svg": 1159,
	"./icon_reservation_active.svg": 1160,
	"./icon_reservation_copy.svg": 793,
	"./icon_room.svg": 794,
	"./icon_schedule.svg": 1161,
	"./icon_schedule_disable.svg": 795,
	"./icon_star_f.svg": 458,
	"./icon_star_n.svg": 459,
	"./icon_stay.svg": 1162,
	"./icon_stay_active.svg": 1163,
	"./icon_sync.svg": 1164,
	"./icon_sync_alt.svg": 1165,
	"./icon_up.svg": 553,
	"./icon_up_gray.svg": 1166,
	"./icon_warning.svg": 796,
	"./icon_wrench.svg": 1168,
	"./identification.svg": 797,
	"./identification_card_back.svg": 1169,
	"./identification_card_front.svg": 1170,
	"./image_ng.svg": 798,
	"./image_ok.svg": 799,
	"./input.svg": 1171,
	"./language-arrow.svg": 1172,
	"./language.svg": 1173,
	"./license.svg": 1174,
	"./license_01.svg": 1175,
	"./license_02.svg": 1176,
	"./link_add.svg": 554,
	"./link_add_hover.svg": 1177,
	"./link_add_normal.svg": 1178,
	"./link_add_orange.svg": 800,
	"./link_deleat.svg": 1179,
	"./link_deleat_hover.svg": 1180,
	"./list_sort_arrow.svg": 1181,
	"./list_sort_arrow_active.svg": 1182,
	"./magnify.svg": 555,
	"./magnifying_glass.svg": 801,
	"./mail-delivery/arrow-right.svg": 802,
	"./mail-delivery/form_delete.svg": 556,
	"./mail-delivery/icon_menu.svg": 1183,
	"./mail-delivery/icon_menu_active.svg": 1184,
	"./mail.svg": 304,
	"./man.svg": 1187,
	"./memo.svg": 383,
	"./miwa-lock/close_gray.svg": 1188,
	"./miwa-lock/key_gray.svg": 1189,
	"./miwa-lock/key_green.svg": 1190,
	"./miwa-lock/miwa_card_read_close.svg": 720,
	"./miwa-lock/miwa_card_read_error.svg": 721,
	"./miwa-lock/miwa_deleat_icon.svg": 803,
	"./miwa-lock/miwa_image.svg": 804,
	"./mobile-menu/icon_checkin.svg": 805,
	"./mobile-menu/icon_clean.svg": 1191,
	"./mobile_logo.svg": 806,
	"./mobile_request/add.svg": 260,
	"./mobile_request/csv_up.svg": 1192,
	"./mobile_request/csv_up_hover.svg": 1193,
	"./mobile_request/csv_up_orange.svg": 1194,
	"./mobile_request/delete.svg": 1195,
	"./mobile_request/delete_orange.svg": 557,
	"./mobile_request/request_icon.svg": 1196,
	"./mobile_request/request_icon_active.svg": 1197,
	"./nationality.svg": 558,
	"./new_identification_card_back.svg": 460,
	"./new_identification_card_front.svg": 461,
	"./new_reservation.svg": 559,
	"./news.svg": 1198,
	"./notice/attention.svg": 1199,
	"./notice/checkin.svg": 1200,
	"./notice/checkout.svg": 1201,
	"./notice/stay.svg": 1202,
	"./nps_down.svg": 1203,
	"./nps_up.svg": 1204,
	"./numberofpeople.svg": 807,
	"./operation-log/icon_menu.svg": 808,
	"./operation-log/icon_menu_active.svg": 1205,
	"./passport.svg": 384,
	"./passport_guide_white.svg": 809,
	"./pay.svg": 810,
	"./people.svg": 811,
	"./phone.svg": 336,
	"./picture.svg": 560,
	"./plan.svg": 812,
	"./plus-white.svg": 236,
	"./plus.svg": 181,
	"./plus_gray.svg": 561,
	"./plus_yellow.svg": 163,
	"./pos_image.svg": 813,
	"./powered_by_aipass.svg": 1207,
	"./poweredby.svg": 1208,
	"./poweredby_logo.svg": 1209,
	"./poweredbyaipass.svg": 1210,
	"./previous-night.svg": 814,
	"./qr-check.svg": 1211,
	"./radio_disabled.svg": 562,
	"./radio_off.svg": 563,
	"./radio_on.svg": 564,
	"./reload.svg": 448,
	"./repeater-icon.svg": 815,
	"./reports_manager/icon_menu.svg": 1213,
	"./reports_manager/icon_menu_active.svg": 1214,
	"./reservation-note/icon_cleaning.svg": 261,
	"./reservation-note/icon_front.svg": 385,
	"./reservation-note/icon_meal.svg": 386,
	"./reservation-note/icon_meal_active.svg": 816,
	"./room-rate/color-check.svg": 565,
	"./room/add.svg": 817,
	"./room/check-box_gray_on.svg": 462,
	"./room/check-box_off.svg": 463,
	"./room/check-box_on.svg": 566,
	"./room/check-box_parent.svg": 567,
	"./room/check-box_yellow_on.svg": 464,
	"./room/preparation.svg": 818,
	"./room/preparation_white.svg": 819,
	"./room/room.svg": 820,
	"./room/room_active.svg": 821,
	"./room/select.svg": 822,
	"./room/settle_gray.svg": 465,
	"./room/settle_orange.svg": 298,
	"./room/settle_white.svg": 466,
	"./room_delete.svg": 1221,
	"./room_delete_gold.svg": 262,
	"./room_manager_arrow.svg": 568,
	"./room_manager_arrow_left.svg": 823,
	"./scan.svg": 569,
	"./search.svg": 1222,
	"./segment-icon3.svg": 824,
	"./select.svg": 99,
	"./select_gray.svg": 217,
	"./select_gray_up.svg": 1223,
	"./select_white.svg": 570,
	"./self-checkin-payment/arrow.svg": 233,
	"./self-checkin-payment/language.svg": 719,
	"./self-checkin-payment/terminal/icon_check.svg": 826,
	"./self-checkin-payment/terminal/icon_ng.svg": 467,
	"./self-checkin/complete-image.svg": 834,
	"./self-checkin/icon_check.svg": 1227,
	"./self-checkin/icon_check_border.svg": 835,
	"./self-checkin/icon_down.svg": 1228,
	"./self-checkin/icon_non.svg": 1229,
	"./self-checkin/icon_up.svg": 1230,
	"./self-checkin/welcome.svg": 1231,
	"./space/help_info.svg": 836,
	"./space/help_time.svg": 837,
	"./space_manager/arrow_left.svg": 838,
	"./space_manager/space_icon.svg": 1232,
	"./space_manager/space_icon_active.svg": 1233,
	"./stay.svg": 839,
	"./surveys/icon_menu.svg": 1234,
	"./surveys/icon_menu_active.svg": 1235,
	"./tab_reservation.svg": 1237,
	"./tab_reservation_active.svg": 1238,
	"./tag.svg": 1240,
	"./tell.svg": 573,
	"./textediter_bold.svg": 574,
	"./textediter_bold_active.svg": 840,
	"./textediter_link.svg": 575,
	"./textediter_link_active.svg": 1241,
	"./textediter_list.svg": 576,
	"./textediter_list_active.svg": 841,
	"./textediter_numberlist.svg": 577,
	"./textediter_numberlist_active.svg": 842,
	"./textediter_title.svg": 843,
	"./textediter_title_active.svg": 844,
	"./textediter_title_en.svg": 845,
	"./textediter_title_en_active.svg": 846,
	"./textediter_underline.svg": 578,
	"./textediter_underline_active.svg": 847,
	"./textediter_video.svg": 848,
	"./upload.svg": 1244,
	"./upload_white.svg": 1245,
	"./user.svg": 263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2103;